<template>

</template>

<script>
export default {
	name: "Token",
	async created() {
		if(sessionStorage.getItem("token") === this.$route.params.token) {
			return
		}

		const token = this.$route.params.token;
		const role = this.$route.params.role;
		sessionStorage.setItem('token', token);
		sessionStorage.setItem('role', role);
		this.$store.commit("auth_login_as", { token: token, role: role });

		const url = `/${role}/profile`;
		const profile = (await this.$http.get(url)).data.data;

		this.$store.commit("auth_success", { token: token, user: profile, role: role })
		this.$store.commit("setLocalLayout", role);

		await this.$router.replace('/');
	}
};
</script>
